import AppModal from "@/components/AppModal";
import {Box} from '@mui/material'
import {KYC_STATUS} from "@/constant/Constant";
import GuideKYC from "@/pages/guide/kyc/GuideKYC";
import GuideKYCPre from "@/pages/guide/kyc/GuideKYCPre";
import {GUIDE_STEP} from "@/utils/userUtils";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

export default function KYCDialog({
                                    open,
                                    onClose,
                                  }) {
  const {t} = useTranslation();
  const [kycPre, setKycPre] = useState(true);
  const {user} = useSelector(state => state.user);

  useEffect(() => {
    if (user?.step) {
      setKycPre(user.step == GUIDE_STEP.NEED_SUBMIT_KYC_PRE);
    }
    if (user?.kycStatus == KYC_STATUS.KYC_STATUS_APPROVED) {
      onClose();
    }
  }, [user]);

  var customBg;
  if (!kycPre) {
    customBg = 'var(--background-color)';
  }
  return (<>
    <AppModal open={open} onClose={onClose} title={t('kyc')} custombg={customBg}>
      {kycPre ? <GuideKYCPre/> : <Box style={{padding: '24px', minHeight: '280px'}}>
        <GuideKYC onComplete={onClose}/>
      </Box>}
    </AppModal>
  </>);
}
